import DocumentHashTabs from './DocumentHashTabs';

export default DocumentHashTabs;
